if (document.querySelector(".rt-pop-announcement")) {
	void import("./RTPop.js").then((e) => new e.default());
}
